module.exports = __webpack_public_path__ + "static/media/plus_blue.1f082451.svg";